import { create } from 'zustand';
import _ from 'lodash';

interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  initPayload: any;
  payload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

export const initCreditCardPayload = {
  name: '', //사용자명
  acct_year: '', //연말정산   년도
  co_cd: '', //회사코드
  co_id: '', //사번
  in_data_seqid: '', //입력데이터 sequence
  family_seqid: 0, //부양가족 sequence
  use_year: '2024', //사용년도
  pension_cd: '0', //사용기간
  data_type: 'G0012', //신용카드유형
  is_htx_pdf: 'Y', //국세청사용여부
  use_place_cd01: 0, //일반금액(근무기간중)
  use_place_cd02: 0, //전통시장(근무기간중)
  use_place_cd02_1: 0, //전통시장(1월~3월)
  use_place_cd02_2: 0, //전통시장(4월~12월)
  use_place_cd03: 0, //대중교통(근무기간중)
  use_place_cd03_1: 0, //대중교통(1월~3월)
  use_place_cd03_2: 0, //대중교통(4월~12월)
  use_place_cd04: 0, //도서공연(근무기간중)
  use_place_cd04_1: 0, //도서공연(1월~3월)
  use_place_cd04_2: 0, //도서공연(4월~12월)
  use_place_cd05: 0, //주택임차료
  total_place_cd01: 0, //일반금액(연중사용액)
  total_place_cd02: 0, //전통시장(연중사용액)
  total_place_cd03: 0, //대중교통(연중사용액)
};

/**
  신용카드
**/
export const creditcardDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initCreditCardPayload,
  payload: _.cloneDeep(initCreditCardPayload),
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));
